import { render, staticRenderFns } from "./SymptomDialog.vue?vue&type=template&id=edd9f0a4&scoped=true&"
import script from "./SymptomDialog.vue?vue&type=script&lang=ts&"
export * from "./SymptomDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd9f0a4",
  null
  
)

export default component.exports